import React, { useRef, useEffect } from 'react';
import Heading from '../Typography/Heading';
import SpecialText from '../Typography/SpecialText';
import MainButton from '../MainButton/MainButton';
import gsap from 'gsap';

const CreatePostBanner = ({ heading, className, children, headingClasses, onButtonClick }) => {
  const buttonWrapperRef = useRef(null);

  useEffect(() => {
    if (buttonWrapperRef.current) {
      gsap.set(buttonWrapperRef.current, { opacity: 0, y: 60 });
      gsap.to(buttonWrapperRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        delay: 0.3,
      });
    }
  }, []);

  return (
    <>
    <div className="tp-container-main mt-28 mb-40 mx-auto">
      <div className={`${className} w-[100%] h-screen relative rounded-xl bg-no-repeat bg-center object-cover bg-cover`}> 
        {/* Dark overlay with transparency */}
        <div className="absolute inset-0 bg-black/40 rounded-xl"></div>
        <div className="mx-[5%] xl:mx-auto xl:w-[1100px] h-full text-center flex flex-col items-center justify-center relative z-10">
          <Heading variant={"h1"} className={`${headingClasses} text-center`}>
            {heading}
          </Heading>

            <SpecialText variant={"IntroParagraph"} className="text-white !capitalize mt-5 max-w-3xl mx-auto">
                Get noticed, get booked, and get paid.
            </SpecialText>
            
            <div ref={buttonWrapperRef}>
              <MainButton
                variant={"medium"}
                className={"mt-10"}
                onClick={onButtonClick}
              >
                Create My Post
              </MainButton>
            </div>
            
            {children}
        </div>
      </div>
      </div>
    </>
  );
};

export default CreatePostBanner
